import { Run, RunDetails } from '@bringg/types';
import { TFunction } from 'i18next';

const get = (run: Run | RunDetails, isManualOptimization: boolean, t: TFunction): string => {
	if (run.route_name) {
		return run.route_name;
	}
	if (run.external_id) {
		return `${t('DISPATCH_LIST.ROUTE')}-${run.external_id}`;
	}
	const routeNumber = isManualOptimization ? run.id : run.id + 1;
	return `${t('DISPATCH_LIST.ROUTE')}-${routeNumber}`;
};

export const runNameProvider = { get };
